module.exports = __webpack_public_path__ + "static/media/SCR-C-049.5f058da5.mp3";